/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventVenue
 */
export interface EventVenue {
    /**
     * 
     * @type {string}
     * @memberof EventVenue
     */
    venueId?: string;
    /**
     * 
     * @type {string}
     * @memberof EventVenue
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EventVenue
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof EventVenue
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof EventVenue
     */
    stateCode?: string;
    /**
     * 
     * @type {string}
     * @memberof EventVenue
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof EventVenue
     */
    postalCode?: string;
    /**
     * 
     * @type {number}
     * @memberof EventVenue
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EventVenue
     */
    longitude?: number;
}

/**
 * Check if a given object implements the EventVenue interface.
 */
export function instanceOfEventVenue(value: object): value is EventVenue {
    return true;
}

export function EventVenueFromJSON(json: any): EventVenue {
    return EventVenueFromJSONTyped(json, false);
}

export function EventVenueFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventVenue {
    if (json == null) {
        return json;
    }
    return {
        
        'venueId': json['venue_id'] == null ? undefined : json['venue_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'addressLine1': json['address_line_1'] == null ? undefined : json['address_line_1'],
        'city': json['city'] == null ? undefined : json['city'],
        'stateCode': json['state_code'] == null ? undefined : json['state_code'],
        'countryCode': json['country_code'] == null ? undefined : json['country_code'],
        'postalCode': json['postal_code'] == null ? undefined : json['postal_code'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
    };
}

export function EventVenueToJSON(json: any): EventVenue {
    return EventVenueToJSONTyped(json, false);
}

export function EventVenueToJSONTyped(value?: EventVenue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'venue_id': value['venueId'],
        'name': value['name'],
        'address_line_1': value['addressLine1'],
        'city': value['city'],
        'state_code': value['stateCode'],
        'country_code': value['countryCode'],
        'postal_code': value['postalCode'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

